export default __webpack_public_path__ + "static/altFavicon-097b3903a4fa978ef21b2c73593b3a1c.ico";